export default __webpack_public_path__ + "static/media/person.c7ac4151.svg";